<div>
	<form
		[formGroup]="securityCodeForm"
		(ngSubmit)="setSecurityCode()"
		novalidate>
		<div class="mt-5">
			<input
				class="input__base"
				type="number"
				formControlName="securityCode"
				[ngClass]="{
					error:
						shouldShowError('securityCode', 'required') ||
						shouldShowError('securityCode', 'max'),
				}" />
		</div>

		<div class="mt-5">
			<activar-button
				text="Aplicar"
				fill="solid"
				color="primary"
				type="submit"
				expand="full" />
		</div>
	</form>
</div>
